class AnnouncementSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.swiper');
    this.announcementStyle = this.dataset.style;
    this.autoplay = this.dataset.autoPlay === 'true';
    this.delay = Number(this.dataset.delay) * 10000;

    this.swiperInstance = {};
    this.settings = this.getSliderSettings();

    this.initSlider();
  }

  initSlider() {
    window.addEventListener('third-party-scripts-loaded', () => {
      this.swiperInstance = new Swiper(this.slider, this.settings);
    });
  }

  getSliderSettings() {
    let settings = {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      autoplay: this.autoplay
        ? {
            delay: this.delay,
            disableOnInteraction: false,
          }
        : false,
      speed: 600,
    };

    return settings;
  }
}

customElements.define('announcement-slider', AnnouncementSlider);
